import { json, Link, useLoaderData } from "@remix-run/react";
import { CheckCircle } from "lucide-react";
import { REQUIRE_PAYMENT, PAYMENT_AMOUNT } from "~/constants";
import { getSession } from "~/services/session.server";
import type { LoaderFunctionArgs } from "@remix-run/node";

export async function loader({ request }: LoaderFunctionArgs) {
  const session = await getSession(request);
  const isPaymentRequired = session.get(REQUIRE_PAYMENT);
  return json({ isPaymentRequired });
}

export default function GetStartedPage() {
  const { isPaymentRequired } = useLoaderData<typeof loader>();
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-2xl mx-auto bg-white border rounded-lg overflow-hidden">
        <div className="p-6 md:p-8">
          <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-2">
            Get Started with Your Assessment
          </h1>
          <p className="text-center text-gray-600 mb-6">
            Please review the requirements before proceeding
          </p>
          <ul className="space-y-4 mb-8">
            <RequirementItem>
              You must be <strong>18 years or older</strong> to complete this
              form.
            </RequirementItem>
            {isPaymentRequired && (
              <RequirementItem>
                A <strong>£{PAYMENT_AMOUNT} payment</strong> will be required
                when you submit your form to secure your assessment.
              </RequirementItem>
            )}
            <RequirementItem>
              <strong>Proof of income</strong>
              will be required during the application process.
            </RequirementItem>
            <RequirementItem>
              Please ensure you have all necessary documents ready before
              starting the form.
            </RequirementItem>
            <RequirementItem>
              The form may take approximately 15-20 minutes to complete.
            </RequirementItem>
          </ul>
          <div className="text-center">
            <Link to="/register/personal-info" className="btn-primary">
              Start Your Application
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function RequirementItem({ children }: { children: React.ReactNode }) {
  return (
    <li className="flex items-start">
      <CheckCircle className="h-5 w-5 mr-3 text-green-500 flex-shrink-0 mt-0.5" />
      <span className="text-gray-700">{children}</span>
    </li>
  );
}
